//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Response$AdminCompanyController_getAllPromoCodes$Status$200,
  ResponseContentType$AdminCompanyController_getAllPromoCodes,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminCompanyController_getAllPromoCodes = (options?: {
  config?: QueryOptions<
    Response$AdminCompanyController_getAllPromoCodes$Status$200[ResponseContentType$AdminCompanyController_getAllPromoCodes]
  >;
}) =>
  useApiClient<
    never,
    Response$AdminCompanyController_getAllPromoCodes$Status$200[ResponseContentType$AdminCompanyController_getAllPromoCodes]
  >({
    method: 'AdminCompanyController_getAllPromoCodes',
    config: options?.config,
  });
